import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { TextField, ClassificatorField, DateRangeField } from '../../atoms';
import { FormActions, AutoCompleteCompaniesField } from '../../components';
import { connect } from 'react-redux';
import { downloadTradingAccountFileByGetURL } from '../../utils/files';
import { links } from '../../utils';
import { FORM_TRANSACTION_FOR_GOS_SEARCH } from '../../constants/formKeys';
import { Collapse, Row, Col, Button } from 'antd';
import * as actions from '../../actions/actionCreators/transactionForGosSearchActionCreators';
import { taTransactionsFilterFields } from '../../constants/formAccountGOSTransactionsFilter';
import { getBasicFilterDateRanges } from '../../utils/dates';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';
import RffFields from '../../atoms/rff/RffFields';

const { Panel } = Collapse;

class TransactionGosFilter extends Component {
  dateFrom = '';
  dateTo = '';
  senderAccountId = undefined;
  receiverAccountId = undefined;
  transactionForGosStatus = undefined;
  transactionType = undefined;
  transactionNumber = undefined;
  currentAccountId = undefined;
  type = undefined;

  static propTypes = {
    t: PropTypes.func.isRequired,
    searchTATransactions: PropTypes.func.isRequired,
    accountId: PropTypes.string,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount = () => this.props.searchTATransactions();

  handleExportTransactions = () => {
    let params = {
      transactionDateFrom: this.dateFrom,
      transactionDateTo: this.dateTo,
      transactionStatus: this.transactionStatus,
      transactionType: this.transactionType,
      senderId: this.senderAccountId,
      receiverId: this.receiverAccountId,
      currentAccountId: this.props.accountId,
      transactionId: this.transactionNumber,
      type: this.type,
    };

    downloadTradingAccountFileByGetURL(
      links.tradingAccountCsv,
      params,
      'gos-account-transactions.csv'
    );
  };

  updateFilterFields = (values) => {
    if (values) {
      this.dateTo = values[taTransactionsFilterFields.DATE_TO];
      this.dateFrom = values[taTransactionsFilterFields.DATE_FROM];
      this.transactionStatus =
        values[taTransactionsFilterFields.TRANSACTION_STATUS];
      this.transactionType =
        values[taTransactionsFilterFields.TRANSACTION_TYPE];
      this.senderAccountId = values[taTransactionsFilterFields.SENDER_ID];
      this.receiverAccountId = values[taTransactionsFilterFields.RECEIVER_ID];
      this.transactionNumber =
        values[taTransactionsFilterFields.TRANSACTION_ID];
      this.type = values[taTransactionsFilterFields.TYPE];
    }
  };

  onSubmit = (values) => {
    this.updateFilterFields(values);
    this.props.searchTATransactions();
  };

  onClear = (form) => {
    form.restart({
      [taTransactionsFilterFields.CURRENT_ACCOUNT_ID]: this.props.accountId,
    });
    this.props.updateFormState(FORM_TRANSACTION_FOR_GOS_SEARCH, { values: {} });
  };

  render() {
    const { t, accountId } = this.props;
    return (
      <div>
        <div className="search-form-container">
          <Collapse defaultActiveKey={['filters']}>
            <Panel key="filters" header={t('filter.panelTitle')}>
              <Form
                initialValues={{
                  [taTransactionsFilterFields.CURRENT_ACCOUNT_ID]: accountId,
                }}
                onSubmit={this.onSubmit}
                render={({ handleSubmit, form }) => (
                  <form onSubmit={handleSubmit}>
                    <FormStateToRedux form={FORM_TRANSACTION_FOR_GOS_SEARCH} />

                    <Row gutter={32}>
                      <Col span={16}>
                        <RffFields
                          label={t('filter.dateRange.title')}
                          names={[
                            taTransactionsFilterFields.DATE_FROM,
                            taTransactionsFilterFields.DATE_TO,
                          ]}
                          placeholder={[
                            t('filter.dateRange.dateFromPlaceholder'),
                            t('filter.dateRange.dateToPlaceholder'),
                          ]}
                          style={{ width: '100%' }}
                          component={DateRangeField}
                          hasFeedback={false}
                          allowClear={false}
                          ranges={getBasicFilterDateRanges(t)}
                        />
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col span={8}>
                        <Field
                          label={t('filter.number')}
                          name={taTransactionsFilterFields.TRANSACTION_ID}
                          component={TextField}
                          hasFeedback={false}
                        />
                      </Col>
                      <Col span={8}>
                        <Field
                          label={t('filter.transactionType')}
                          name={taTransactionsFilterFields.TRANSACTION_TYPE}
                          component={ClassificatorField}
                          classificatorType={
                            ClassificatorField.types.gosTransactionType
                          }
                          hasFeedback={false}
                        />
                      </Col>
                      <Col span={8}>
                        <Field
                          label={t('filter.type')}
                          name={taTransactionsFilterFields.TYPE}
                          component={ClassificatorField}
                          classificatorType={
                            ClassificatorField.types
                              .tradingAccountTransactionRowType
                          }
                          hasFeedback={false}
                        />
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col span={8}>
                        <Field
                          label={t('filter.senderAccount')}
                          name={taTransactionsFilterFields.SENDER_ID}
                          component={AutoCompleteCompaniesField}
                          hasFeedback={false}
                        />
                      </Col>
                      <Col span={8}>
                        <Field
                          label={t('filter.receiverAccount')}
                          name={taTransactionsFilterFields.RECEIVER_ID}
                          component={AutoCompleteCompaniesField}
                          hasFeedback={false}
                        />
                      </Col>
                    </Row>
                    <Row gutter={32}>
                      <Col span={8}>
                        <Field
                          label={t('filter.transactionStatus')}
                          name={taTransactionsFilterFields.TRANSACTION_STATUS}
                          component={ClassificatorField}
                          classificatorType={
                            ClassificatorField.types.transactionForGosStatus
                          }
                          hasFeedback={false}
                        />
                      </Col>
                    </Row>
                    <FormActions>
                      <Button onClick={() => this.onClear(form)}>
                        {t('filter.clearBtn')}
                      </Button>
                      <Button type="primary" htmlType="submit">
                        {t('filter.submitBtn')}
                      </Button>
                    </FormActions>
                  </form>
                )}
              />
            </Panel>
          </Collapse>
          <FormActions>
            <Button onClick={this.handleExportTransactions}>
              {t('exportCsvBtn')}
            </Button>
          </FormActions>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector(FORM_TRANSACTION_FOR_GOS_SEARCH);

const mapDispatchToProps = {
  ...actions,
  searchTATransactions: actions.searchTATransactionsAction,
  updateFormState,
};

const mapStateToProps = (state, ownProps) => ({
  filterValues: selector(state),
  accountId: ownProps.accountId,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionGosFilter);
